export default __webpack_public_path__ + "static/PMG_EGIB_HOHH_PW_AGENCY_BM-78ac69f52c03d240b3873b59659c6842.pdf";